module.exports = __webpack_public_path__ + "img/text_congratulations_finish.de24359f.svg";